import React from 'react';
import {connect} from 'react-redux';
import {DIALOG_TYPES} from '../../constants/dialogs';
import ModalTemplateExample from './templates/ModalTemplateExample';
import ModalConfirmRegistration from './templates/ModalConfirmRegistration';
import ModalReportForm from './templates/ModalReportForm';
import ModalShareLink from './templates/ModalShareLink';
import ModalChangePassword from './templates/ModalChangePassword';
import ModalVideoSessionInvitation from './templates/ModalVideoSessionInvitation';
import ModalChangeUserStatus from './templates/ModalChangeUserStatus';
import ModalUploadFile from './templates/ModalUploadFile';
import ModalVideoSessionInite from './templates/ModalVideoSessionInite';
import ModalConfirmRemove from './templates/ModalConfirmRemove';
import ModalContactCard from './templates/ModalContactCard';
import ModalInvitedDeclined from './templates/ModalInvitedDeclined';
import ModalAddContacts from './templates/ModalAddContacts';
import ModalLoading from './templates/ModalLoading';
import ModalVideoPollRecordSaving from './templates/ModalVideoPollRecordSaving';
import ModalVideoPollRecordInvite from './templates/ModalVideoPollRecordInvite';
import './Modal.less';

const ModalPopup = (props) => {
  const renderModalByTemplate = () => {
    const {templateType, data} = props.rModals;

    if (!templateType) {
      return null;
    }

    // TODO: REFACTORING MODALS

    switch (templateType) {
    case DIALOG_TYPES.MODAL_TYPE_EXAMPLE:
      return <ModalTemplateExample {...data} />;
    case DIALOG_TYPES.MODAL_CONFIRM_REGISTRATION:
      return <ModalConfirmRegistration {...data} />;
    case DIALOG_TYPES.MODAL_REPORT_FORM:
      return <ModalReportForm {...data} />;
    case DIALOG_TYPES.MODAL_SHARE_LINK:
      return <ModalShareLink {...data} />;
    case DIALOG_TYPES.MODAL_CHANGE_PASSWORD:
      return <ModalChangePassword {...data} />;
    case DIALOG_TYPES.MODAL_VIDEO_SESSION_INVATION:
      return <ModalVideoSessionInvitation {...data} />;
    case DIALOG_TYPES.MODAL_CHANGE_USER_STATUS:
      return <ModalChangeUserStatus {...data} />;
    case DIALOG_TYPES.MODAL_UPLOAD_FILE:
      return <ModalUploadFile {...data} />;
    case DIALOG_TYPES.MODAL_VIDEO_SESSION_INVITE:
      return <ModalVideoSessionInite {...data} />;
    case DIALOG_TYPES.MODAL_CONFIRM_REMOVE:
      return <ModalConfirmRemove data={data} />;
    case DIALOG_TYPES.MODAL_CONTACT_CARD:
      return <ModalContactCard {...data} />;
    case DIALOG_TYPES.MODAL_INVITED_DECLINED:
      return <ModalInvitedDeclined {...data} />;
    case DIALOG_TYPES.MODAL_ADD_CONTACTS:
      return <ModalAddContacts {...data} />;
    case DIALOG_TYPES.MODAL_LOADING:
      return <ModalLoading {...data} />;
    case DIALOG_TYPES.MODAL_VIDEO_POLL_RECORD_SAVING:
      return <ModalVideoPollRecordSaving {...data} />;
    case DIALOG_TYPES.MODAL_VIDEO_POLL_RECORD_INVITE:
      return <ModalVideoPollRecordInvite {...data} />;
    default:
    }

    return null;
  };

  return <div>{renderModalByTemplate()}</div>;
};

function mapStateToProps({rModals}) {
  return {rModals};
}

export default connect(mapStateToProps, null)(ModalPopup);
